import * as angular from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';
import { States } from "../../shared/config/constant.module";
import template from './scorecardChecklist.tpl.html';
import { StateParams } from "../../common";
import LoaderServiceName, { LoaderService } from "../../components/loader/loader.service";
import ScoreCardServiceName, { ScoreCardService } from '../../services/dashboard/scorecard.service';
import NavigationServiceName, { NavigationService } from "../../services/navigation/navigation.service";
import { Plant } from '../../models/navigation';
import { apsViewModels } from '../../shared/dto/APS.ViewModels';
import NotifyServiceName, { NotifyService } from "../../services/notify/notify.service";
import { apsEnums } from '../../shared/dto/aps.enums';
import { CheckListsService } from '../../services/checkLists/checkLists.service';
import { openCheckListReportDetails } from '../checkLists/checkListReportDetails.controller';
import Chart = require('chart.js');

let requires = [LoaderServiceName, ScoreCardServiceName, NavigationServiceName];

interface ScorecardController {
  plants: Plant[];
  selectedPlant: Plant;
  form: angular.IFormController;
  reportData: apsViewModels.ScoreCardCheckListInstance;
}

export interface ScorecardParams extends StateParams {
  reportPlantId: string;
  reportStartDate: Date;
}

class ScorecardCtrl implements ScorecardController {
  private checkListsService: CheckListsService;
  checkfilter: apsEnums.CheckListReportFilter;
  plants: Plant[];
  selectedPlant: Plant;
  reportStartDate: Date;
  futureDate: Date;
  chartOptions: any;
  pieCharts: any;
  barChartsData: any = [];
  failedSummaryBarChart: Chart;
  scorecardWeeklySummary: any;
  scorecardFailedSummaries: any;
  reportData: apsViewModels.ScoreCardCheckListInstance;
  form: angular.IFormController;
  $state: angular.ui.IStateService;
  loaderService: LoaderService;
  scorecardService: ScoreCardService;
  notifyService: NotifyService;
  $q: angular.IQService;

  reportLoadingPromise: angular.IDeferred<any>;
  reportAvailableThisWorkaround: any;
  curatedShops: apsViewModels.ShopNavigation[];

  private $stateParams: ScorecardParams;
  private $modal: mm.foundation.modal;
  scoreCardSummeryEnum = {
    totalChecks: "Total Checks",
    passedChecks: "Passed Checks",
    failedChecks: "Failed Checks",
    incompleteChecks: "Incomplete Checks",
  }
  $timeout: angular.ITimeoutService;

  constructor(
      checkListsService: CheckListsService,
      $state: angular.ui.IStateService,
      $stateParams: ScorecardParams,
      navigationService: NavigationService,
      scorecardService: ScoreCardService,
      loaderService: LoaderService,
      notifyService: NotifyService,
      $modal: mm.foundation.modal,
      $q: angular.IQService,
      $timeout: angular.ITimeoutService) {

    var vm = this;

    this.checkListsService = checkListsService;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.loaderService = loaderService;
    this.scorecardService = scorecardService;
    this.notifyService = notifyService;
    this.$modal = $modal;
    this.$q = $q;
    this.$timeout = $timeout;

    var now = moment().startOf('hour');
    this.reportStartDate = now.clone().toDate();
    this.futureDate = now.clone().add(1, 'days').toDate();
    this.reportData = null;
    var promise = navigationService.getNavigation().then((navModel) => {
      this.plants = navModel.plants();
      this.selectedPlant = navModel.selectedPlant;
      this.checkfilter = apsEnums.CheckListReportFilter.AllCheckLists;
      return this.loadState($stateParams);
    });
    
    loaderService.loadingPromise(promise);this.chartOptions = {
      chart: {
        type: "pieChart",
        x: (d: { label: string }) => d.label,
        y: (d: { value: number }) => d.value,
        height:450,
        width:450,
        showLabels: true,
        responsive: true, // Makes the chart responsive
        duration: 500, // Duration of the animation
        labelThreshold: 0.03, // Show labels for slices larger than 5%
        labelSunbeamLayout: false,
        labelsOutside: false,
        donut: true, // Donut chart
        donutRatio: 0.35, // Size of the donut hole
        transitionDuration: 500,
        showLegend: false,  // Disables the legend
        showControls: false,  // Disables the controls
        legend: {
          margin: {
            top: 5,
            right: 30,
            bottom: 5,
            left: 0,
          },
        },   
        pie: {
          dispatch: {
            elementClick: function(e) { 
              if(e.data.shopFailedSummaries) {vm.generateBarChart(e);} else {return;}
            }
          }
        }
      }
    };
    
  }  
  generateBarChart(e) {
    this.barChartsData = [{
      title: e.data.label.length > 65 ? e.data.label.slice(0, 65)+'...': e.data.label, 
      labels:e.data.shopFailedSummaries.map((x)=>{return 'Shop '+x.shopName;}),
      values:e.data.shopFailedSummaries.map((x) => { return  Math.round(x.count) })
    }];
    // update the chart with new data else create a new chart
    if(this.failedSummaryBarChart !== undefined && this.failedSummaryBarChart.ctx !== null) { 
      this.failedSummaryBarChart.data.datasets[0].data=[];
      this.failedSummaryBarChart.data.labels = this.barChartsData[0].labels;
      this.failedSummaryBarChart.data.datasets[0].label= this.barChartsData[0].title;
      this.failedSummaryBarChart.data.datasets[0].data = this.barChartsData[0].values;
      this.failedSummaryBarChart.update();
      return;
    } 
    //chart initialization
    this.$timeout(()=>{let ctx: any = document.getElementById('failedSummaryBarChart');
      if(!ctx) return;
      this.failedSummaryBarChart = new Chart(ctx.getContext('2d'), {
        type: 'bar',
        data: {
          labels: this.barChartsData[0].labels,
          datasets: [{
            label: this.barChartsData[0].title,
            data: this.barChartsData[0].values,
            backgroundColor: [
                'rgba(255, 99, 132, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)'
            ],
            borderColor: [
                'rgba(255, 99, 132, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)'
            ],
            borderWidth: 1,
          }]
        },
        options: {
          responsive: true,
          scales: {
            xAxes: [{
              gridLines: { display: false },
            }],
            yAxes: [{
              type: 'linear',
              gridLines: { display: false },
              ticks: {
                min: 0,
              }
            }]
          }
        }
      });
    },0);
  }
  
  loadState(params: ScorecardParams): angular.IPromise<any> {
    if (params.reportPlantId) {
      var plant = _.find(this.plants, { id: params.reportPlantId });
      this.selectedPlant = plant;
    }

    if (params.reportStartDate) {
      var reportStartDate = moment(params.reportStartDate);
      if (reportStartDate.isValid()) {
        this.reportStartDate = reportStartDate.toDate();
      }
    }
    this.generateReport();
    return this.$q.when();
  }

  saveState(): void {
    var reportPlantId = this.selectedPlant ? this.selectedPlant.id : undefined;
    if (reportPlantId === this.$stateParams.plantId) {
      reportPlantId = undefined;
    }

    var params: ScorecardParams = {
      plantId: this.$stateParams.plantId,
      shopId: this.$stateParams.shopId,
      userId: this.$stateParams.userId,
      reportPlantId: reportPlantId,
      reportStartDate: this.reportStartDate ? this.reportStartDate : undefined,
    };

    this.$state.transitionTo(this.$state.current.name, params);
  }

  generateReport() {
    if (this.form.$invalid) {
      return;
    }

    if (this.reportStartDate >= this.futureDate) {
      this.notifyService.error("Report Date shouldn't be in the future");
      return;
    }

    this.saveState();

    this.curatedShops = this.selectedPlant.shops;
    if (this.selectedPlant.name.indexOf("Jack") === 0) {
      this.curatedShops = this.selectedPlant.shops.slice(0, 2);
    } else if (this.selectedPlant.name.indexOf("War") === 0) {
        this.curatedShops  = this.selectedPlant.shops.slice(0, 3);
    }

    this.loaderService.loadingPromise(this.runReport());
  }

  private runReport(): angular.IPromise<any> {
    let promise = this.scorecardService.getScorecardChecklists(this.selectedPlant.id, this.reportStartDate);
    promise.then((result: apsViewModels.ScoreCardCheckListInstance) => {
      this.reportData = result;
      this.processPieChart(result);
    });
    return promise;
  }

  processPieChart(result: apsViewModels.ScoreCardCheckListInstance) {
    // reset the chart
    if (this.failedSummaryBarChart !== undefined) {
      this.failedSummaryBarChart.destroy();
    }

    this.scorecardWeeklySummary = [];
    this.scorecardFailedSummaries = [];
    
    if (!_.isEmpty(result.scorecardWeeklySummary)) {
      this.scorecardWeeklySummary = Object.keys(result.scorecardWeeklySummary)
        .filter((item) => item !== "totalChecks")
        .map((key) => {
          return {
            label: this.scoreCardSummeryEnum[key], 
            value: result.scorecardWeeklySummary[key] 
          };
        });
    }

    if (!_.isEmpty(result.scorecardFailedSummaries)) {
      this.scorecardFailedSummaries = result.scorecardFailedSummaries.map(
        (i) => {
          return {
            label: i["failedCheckName"],
            value: i["count"],
            shopFailedSummaries: i["shopFailedSummaries"]
          };
        }
      ).sort((a, b) => b.value - a.value)
      .slice(0, 10);
    }
    // create pie chart data
    this.pieCharts = [
      {
        id: "Weekly Summary",
        data: this.scorecardWeeklySummary,
        labelType: function(d) {
          return d.data.label + " - " + Math.round(d.data.value/result.scorecardWeeklySummary["totalChecks"]*100) + "%";
        },
      },
      {
        id: "Failed Summary",
        data: this.scorecardFailedSummaries,
        labelType: "percent",
      },
    ];
  }

  getChartOptions(chartId: string) {
    let pieChart = this.pieCharts.find(chart => chart.id === chartId);
    this.chartOptions.chart.labelType = pieChart.labelType;
    this.chartOptions.chart.title = pieChart.id;
    return this.chartOptions;
  }

  exportToExcel() {
    this.loaderService.loadingPromise(
      this.scorecardService.exportToExcelV2(this.selectedPlant.name, this.reportStartDate, this.reportData.excel)
    );
  }

  openModal(chekInstanceData) {
     var promise =  this.checkListsService.getCheckListReportDetail(
              chekInstanceData.id, chekInstanceData.plantLocationId, chekInstanceData.scheduledOn, this.checkfilter
            );  
     this.loaderService.loadingPromise(promise);

     promise.then((data: apsViewModels.CheckListInstanceReportDetail) => {
      openCheckListReportDetails({
        checkListInstance: chekInstanceData,
        detail: data
      }, this.$modal);
    });
  }

  updatePlant() {
    this.reportData = null;
  }

  getFormattedDate(currentDate: Date): string {
    var utc = new Date(currentDate.getUTCFullYear(), currentDate.getUTCMonth(), currentDate.getUTCDate(),
                       currentDate.getUTCHours(), currentDate.getUTCMinutes(), currentDate.getUTCSeconds());
    return moment(utc).format("dddd, MM/DD/YYYY");
  }

  isroleunique(role: string): boolean {
    return (role === "Production Superintendent" || role === "Plant Manager");
  }

  getShopcount(): number {
    return this.curatedShops.length;
  }

  getOuterColor(shop: apsViewModels.ShopNavigation, role: string, processDate: Date): string {
    var now = moment().startOf('hour').toDate();
    if (processDate > now && role.indexOf("Plant Manager") === -1) {
      return '';
    } else if (role.indexOf("Plant Manager") !== -1) {
      var allchecklists: apsViewModels.ScorecardDetailItems[] = [];
      this.reportData.scorecardCheckListItems.forEach(x => {
        x.scorecardDetailItems.forEach(y => {
          allchecklists.push(y);
        });
      });
      var filteredbyRole = allchecklists.filter(x => x.roleName === role && x.status === apsEnums.CheckListStatus.Complete);
      if (filteredbyRole.length > 0) {
        return 'green';
      } else {
        return 'red';
      }
    } else if (role.indexOf("Superintendent") !== -1) {
      var filtered = _.find(this.reportData.scorecardCheckListItems, x => x.processDate === processDate);
      var filteredbyRoleandStatus = filtered.scorecardDetailItems.filter(x =>
                                                        x.roleName === role && x.status === apsEnums.CheckListStatus.Complete);
      var filteredbyRole = filtered.scorecardDetailItems.filter(x => x.roleName === role);
      if (filteredbyRole.length > 0 && filteredbyRoleandStatus.length > 0) {
        return 'green';
      } else {
        return 'red';
      }
    } else {
      var filtered = _.find(this.reportData.scorecardCheckListItems, x => x.processDate === processDate);
      var filteredbyRoleandStatus = filtered.scorecardDetailItems.filter(x => 
                            x.roleName === role && x.shopName === shop.name && x.status === apsEnums.CheckListStatus.Complete);
      var filteredbyRole = filtered.scorecardDetailItems.filter(x => x.roleName === role && x.shopName === shop.name);
      if (filteredbyRole.length > 0 && filteredbyRole.length === filteredbyRoleandStatus.length) {
        return 'green';
      } else if (filteredbyRoleandStatus.length > 0) {
        return 'yellow';
      } else {
        return 'red';
      }
    }
  }

  scorecardExists(): boolean {
    var allchecklists: apsViewModels.ScorecardDetailItems[] = [];
    if (this.reportData) {
      this.reportData.scorecardCheckListItems.forEach(x => x.scorecardDetailItems.forEach(y => allchecklists.push(y)));
      return allchecklists.length > 0;
    }
    return false;
  }

  getDescription(shop: apsViewModels.ShopNavigation, role: string, processDate: Date): apsViewModels.ScorecardDetailItems[] {
    var now = moment().startOf('hour').toDate();
    if (processDate > now) {
      var allchecklists: apsViewModels.ScorecardDetailItems[] = [];
      return allchecklists;
    }
    if (role.indexOf("Plant Manager") !== -1) {
      var allchecklists: apsViewModels.ScorecardDetailItems[] = [];
      var allchecklists1: apsViewModels.ScorecardDetailItems[] = [];
      this.reportData.scorecardCheckListItems.forEach(x => {
        x.scorecardDetailItems.forEach(y => allchecklists1.push(y));
      });
      var filteredbyRole = allchecklists1.filter(x => x.roleName === role && x.status === apsEnums.CheckListStatus.Complete);
      var filterByWeek = allchecklists1.filter(x => x.roleName === role);

      if (filteredbyRole.length > 0) {
        allchecklists.push(filteredbyRole[0]);
        return allchecklists;
      } else {
        allchecklists.push(filterByWeek[0]);
        return allchecklists;
      }
    } else if (role.indexOf("Superintendent") !== -1) {
      var allchecklists: apsViewModels.ScorecardDetailItems[] = [];
      var filtered = _.find(this.reportData.scorecardCheckListItems, x => x.processDate === processDate);
      var filteredbyRole = filtered.scorecardDetailItems.filter(x => x.roleName === role);
      var filteredbyRoleAndStatus = filtered.scorecardDetailItems.filter(x =>
                                                               x.roleName === role && x.status === apsEnums.CheckListStatus.Complete);
      if (filteredbyRoleAndStatus.length > 0) {
        allchecklists.push(filteredbyRoleAndStatus[0]);
        return allchecklists;
      } else {
        allchecklists.push(filteredbyRole[0]);
        return allchecklists;
      }
    } else {
      var filtered = _.find(this.reportData.scorecardCheckListItems, x => x.processDate === processDate);
      var filteredbyRole = filtered.scorecardDetailItems.filter(x => x.roleName === role && x.shopName === shop.name);
      return filteredbyRole;
    }
  }
}

export default angular.module('aps.controller.scorecard', requires)
  .config(function ($stateProvider: angular.ui.IStateProvider) {
    $stateProvider.state({
      name: States.SCORECARD,
      url: '/scorecard',
      controller: 'ScorecardCtrl as vm',
      template: template,
      data: {
        pageTitle: 'Scorecard Checklist',
        v2Uri: 'aps/reports/lpa-score-card'
      }
    });
  })
  .controller('ScorecardCtrl', ScorecardCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/dashboard/scorecardChecklist.controller.ts